import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import Keycloak from 'keycloak-js';
import { Skeleton } from 'primeng/skeleton';
import { BuildInfoService } from 'src/app/services/build-info/build-info.service';
import { ArrayUtils } from 'src/app/shared/utils/array.utils';
import { environment } from 'src/environments/environment';
import { AppMenuComponent } from '../menu/menuList/app.menu.component';
import { AppConfig, LayoutService } from '../service/app.layout.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-sidebar',
  templateUrl: './app.sidebar.component.html',
  imports: [RouterLink, AppMenuComponent, Skeleton, AsyncPipe],
})
export class AppSidebarComponent implements OnDestroy {
  readonly layoutService = inject(LayoutService);
  readonly el = inject(ElementRef);
  private readonly keycloak = inject(Keycloak);
  private readonly buildInfoService = inject(BuildInfoService);

  public config$ = this.layoutService.config$;
  public buildInfoResource = this.buildInfoService.buildInfoResource;
  public changelogUrl = environment.changelogUrl;

  public resetOverlay() {
    if (this.layoutService.state.overlayMenuActive) {
      this.layoutService.state.overlayMenuActive = false;
    }
  }

  public ngOnDestroy() {
    this.resetOverlay();
  }

  public isStatic(config: AppConfig) {
    return config.menuMode === 'static';
  }

  public isCompact(config: AppConfig) {
    return config.menuMode === 'compact';
  }

  public get logoSrc(): string {
    const tokenParsed = this.keycloak.tokenParsed;
    const roles = ArrayUtils.ensureArray(tokenParsed?.realm_access?.roles);
    const isKibCore = roles.includes('kib_core');

    return isKibCore ? 'assets/layout/images/logo_rgsnl.svg' : 'assets/layout/images/logo.svg';
  }
}
